import React from 'react';
import styles from './EventInfo.module.scss';
import Name from './Name/Name';

const EventInfo = ({ eventId, league, teams, categoryName, liveStatistics }) => {
    return (
        <td data-tip data-for={eventId} className={styles.eventInfo}>
            <Name
                eventId={eventId}
                league={league}
                teams={teams}
                categoryName={categoryName}
                liveStatistics={liveStatistics}
            />
        </td>
    );
};

export default EventInfo;
